import { Card } from "components/ui/card";
import { Trash } from "lucide-react";
import { logoFlipFlop } from "assets";
import { Service } from "utils/services";

interface StudioMusicPlayerProps {
  music: any;
  onAddMusic: () => void;
  onRemoveMusic: () => void;
}

export function StudioMusicPlayer({ music, onAddMusic, onRemoveMusic }: StudioMusicPlayerProps) {
  return (
    <>
      <Card key={music.id} className="p-2 rounded-md w-full cursor-pointer me-2 relative">
        <button onClick={onRemoveMusic} className="absolute -top-3 -left-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-red-600 text-white hover:bg-red-700">
          <Trash size={16} />
        </button>

        <div className="flex gap-3 items-center w-full">
          {/* Image Thumbnail */}
          <div className="w-14 h-14">
            <img src={music.thumbnail ?? logoFlipFlop} alt={music.name} className="w-14 h-14 rounded-md object-cover" />
          </div>

          {/* Sound Details (clickable for play/pause too) */}
          <div className="flex-1 space-y-1" onClick={onAddMusic}>
            <p className="text-md font-semibold line-clamp-1">{music?.sound_title}</p>
            <p className="text-muted-foreground text-xs font-semibold line-clamp-1">
              {music?.sound_singer || "Unknown"} • {music?.sound_genres || "None"} • {Service.formatSoundDuration(music.sound_duration)} • {music?.usage_count} Used
            </p>
            <p className="text-muted-foreground text-sm font-semibold line-clamp-1">{music?.hashtag}</p>
          </div>
        </div>
      </Card>
    </>
  );
}

